import SortIcon from './component'

export default SortIcon
